import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border h-15px w-15px align-middle text-gray-400" }, null, -1)
const _hoisted_4 = { key: 1 }


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingButton',
  props: {
    isLoading: { type: Boolean },
    saveTitle: {},
    savingTitle: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    disabled: props.isLoading
  }, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createTextVNode(_toDisplayString(props.savingTitle ? props.savingTitle : _ctx.$t("action.waiting")) + " ", 1),
          _hoisted_3
        ]))
      : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(props.saveTitle ? props.saveTitle : _ctx.$t("action.submit")), 1))
  ], 8, _hoisted_1))
}
}

})